import { ICellRendererParams } from "ag-grid-community";
import { CircleCheck, X } from "lucide-react";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { StripeApiProductFeatureDto } from "@intelligems/ig-types";
import { useTheme } from "@mui/material";

export const ValueColumn = (
  params: ICellRendererParams<StripeApiProductFeatureDto>
) => {
  const theme = useTheme();
  if (!params.data?.id) {
    return null;
  }

  if (params.data.metadata.value === true) {
    return <CircleCheck size={18} color={theme.igIconColors.success} />;
  }

  if (params.data.metadata.value === false) {
    return <X size={18} color={theme.igIconColors.error} />;
  }

  return <IgTypography>{params.data.metadata.value}</IgTypography>;
};
